<template>
  <div class="fts-settings-page">
    <header class="fts-settings-head">
      <div>
        <h1>People &amp; seats</h1>
        <p>
          Who is in this workspace, who is waiting to join and who has left. Actor seats are
          given by Inistate staff until seat billing is live.
        </p>
      </div>
    </header>

    <fts-users embedded :initial-tab="tab" @tab="setTab" />
  </div>
</template>

<script>
/**
 * Settings › People & seats — today's people page, moved into the frame (proposal §5, P0:
 * "existing components moved in as pages"). The table the design draws (D-7: seat, connected
 * clients, the GNey switch) replaces it in P2; giving seats waits for Stripe seat sync (W-15).
 *
 * The tab rides the settings URL as ?tab=, pushed like the /users routes it replaces, so a
 * refresh, a shared link and Back all behave as they did there. Embedded, FTSUsers keeps its
 * tab as its own state and follows this prop when the URL moves.
 */
import FTSUsers from "../../client/FTSUsers";

const TABS = ["active", "lobby", "inactive", "invitation"];

export default {
  name: "SettingsPeople",
  components: { "fts-users": FTSUsers },
  props: {
    workspaceId: [String, Number],
  },
  computed: {
    tab() {
      const asked = this.$route.query && this.$route.query.tab;
      return TABS.indexOf(asked) >= 0 ? asked : "active";
    },
  },
  methods: {
    setTab(tab) {
      if (tab === this.tab) return;
      this.$router
        .push({ name: "settings", params: { section: "people" }, query: tab === "active" ? {} : { tab } })
        .catch(() => {});
    },
  },
};
</script>
